<script>
import mixinComponent from '../components/js/Mixins/mixinComponent.js'
import { globalVariablesMixin } from '../components/js/Mixins/global.js'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  computed: {
    backgroundUrl() {
      return `/assets/img/${this.conf.theme_dir}-background.png`
    },
  },
}
</script>
<template>
  <div>
    <main class="main-container" style="display: block">
      <div id="login" class="row min-h-fullscreen">
        <div class="col-md-6 col-xs-none background-right p-0">
          <img :src="backgroundUrl" alt="" />
          <div v-if="$te('login.contact.phoneNumber') || $te('login.contact.addressEmail')" class="contact">
            <p class="title">{{ $t('login.contact.title') }}</p>
            <div v-if="$te('login.contact.phoneNumber')">
              <label>{{ $t('login.contact.phone') }}</label>
              <p>{{ $t('login.contact.phoneNumber') }}</p>
            </div>
            <div v-if="$te('login.contact.addressEmail')">
              <label>{{ $t('login.contact.email') }}</label>
              <p>{{ $t('login.contact.addressEmail') }}</p>
            </div>
          </div>
        </div>

        <div class="col-md-6 align-self-center background-left flex-column">
          <div class="form-container">
            <div class="image_logo" :title="conf.theme_dir"></div>

            <router-view></router-view>
          </div>
        </div>

        <div id="contact" v-if="$te('login.contact.phoneNumber') || $te('login.contact.addressEmail')" class="contact">
          <div v-if="$te('login.contact.phoneNumber')">
            <label>{{ $t('login.contact.phone') }}</label>
            <p>{{ $t('login.contact.phoneNumber') }}</p>
          </div>
          <div v-if="$te('login.contact.addressEmail')">
            <label>{{ $t('login.contact.email') }}</label>
            <p>{{ $t('login.contact.addressEmail') }}</p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
